import { createFileRoute } from '@tanstack/react-router'
import { AdHocChartViewer } from 'pages/processData/AdHocChartViewer'
import { processDataViewSearchSchema } from 'routes/process-data/-searchParams'

export const Route = createFileRoute('/process-data/view')({
  component: RouteComponent,
  validateSearch: processDataViewSearchSchema,
  staticData: {
    title: 'Process Data View',
    layout: {
      enableScrolling: true,
    },
  },
})

function RouteComponent() {
  const { orgId, siteId, alertId, sensorIds, start, end } = Route.useSearch()

  return (
    <AdHocChartViewer
      orgId={orgId}
      siteId={siteId}
      alertId={alertId}
      sensorIdsParam={sensorIds}
      start={start}
      end={end}
    />
  )
}
